import '../plugins/thumbnails-gallery'

export default {
  init() {
    /* Thumbnails gallery */
    $('.woocommerce-product-gallery__wrapper').each(function() {
      $(this).ThumbnailsGallery()
    })

    /* Reorder checkout fields */
    if ($('.woocommerce-password-notice').length) {
      $('.woocommerce-password-notice').detach().insertAfter('fieldset legend')
    }
    if ($('.woocommerce-edit-address #shipping_postcode_field').length) {
      $('.woocommerce-edit-address #shipping_postcode_field').detach().insertAfter('#shipping_address_2_field')
    }
    if ($('.woocommerce-edit-address #billing_postcode_field').length) {
      $('.woocommerce-edit-address #billing_postcode_field').detach().insertAfter('#billing_address_2_field')
    }
    if ($('.woocommerce-edit-address #billing_email_field').length) {
      $('.woocommerce-edit-address #billing_email_field').detach().insertAfter('#billing_last_name_field')
    }
    if ($('.woocommerce-edit-address #billing_phone_field').length) {
      $('.woocommerce-edit-address #billing_phone_field').detach().insertAfter('#billing_email_field')
    }

    /* Address 2 is still a problem after all these years */
    $('label[for="billing_address_2"]').removeClass('screen-reader-text').text($('#billing_address_2').attr('placeholder'))
    $('#billing_address_2').attr('placeholder', '')
    $('label[for="shipping_address_2"]').removeClass('screen-reader-text').text($('#shipping_address_2').attr('placeholder'))
    $('#shipping_address_2').attr('placeholder', '')
    setTimeout(function() {
      $('#billing_address_2').attr('placeholder', '')
      $('#shipping_address_2').attr('placeholder', '')
    }, 100)

    /* My account */
    $('.woocommerce-MyAccount-content input[type!="checkbox"]').on('blur input focus', function() {
      const $this = $(this)
      const $field = $this.closest('.woocommerce-form-row').find('label')
      if ($this.val()) {
        $field.addClass('filled')
      } else {
        $field.removeClass('filled')
      }
    })
    $('.woocommerce-MyAccount-content input[type!="checkbox"]').on('focus', function() {
      const $this = $(this)
      const $field = $this.closest('.woocommerce-form-row').find('label')
      if ($this) {
        $field.addClass('filled')
      } else {
        $field.removeClass('filled')
      }
    })
    $('.woocommerce-MyAccount-content input[type!="checkbox"]').each(function() {
      const $this = $(this)
      const $field = $this.closest('.woocommerce-form-row').find('label')
      if ($this.val()) {
        $field.addClass('filled')
      }
    })
    $('.woocommerce-address-fields__field-wrapper input[type!="checkbox"]').each(function() {
      const $this = $(this)
      const $field = $this.closest('.form-row').find('label')
      if ($this.val()) {
        $field.addClass('filled')
      }
    })
    $('.woocommerce-address-fields__field-wrapper input[type!="checkbox"]').on('blur input focus', function() {
      const $this = $(this)
      const $field = $this.closest('.form-row').find('label')
      if ($this.val()) {
        $field.addClass('filled')
      } else {
        $field.removeClass('filled')
      }
    })
    $('.woocommerce-MyAccount-content input[type!="checkbox"]').on('focus', function() {
      const $this = $(this)
      const $field = $this.closest('.woocommerce-form-row').find('label')
      if ($this) {
        $field.addClass('filled')
      } else {
        $field.removeClass('filled')
      }
    })
  },
}
